// Automatic summaries describe the response at creation. After a correction,
// use the current configured label and the recorded offence; keep the saved
// sentence and rule execution intact as historical evidence.
export function getConsequenceSummary(event, typeConfig = {}) {
  const record = event.originalData || event;
  const automaticSummary = event.autoGenerated && record.consequenceDetails;
  if (!automaticSummary) return event.offence || event.reason;

  const receipt = record.escalationPersistence;
  const lastStep = receipt?.steps?.at(-1);
  const issuedType = lastStep?.toType || lastStep?.outputType?.value || receipt?.creationType;
  const reviewOriginalType = record.modifiedInAdjudication && record.originalData?.type;
  const corrected = (issuedType && issuedType !== event.type) ||
    (reviewOriginalType && reviewOriginalType !== event.type) ||
    record.actionLog?.some(entry => entry.action === 'edited' &&
      ['type', 'typeId', 'typeName', 'consequenceType'].some(field =>
        entry.metadata?.previousType?.[field] !== entry.metadata?.newType?.[field]));

  if (!corrected) return automaticSummary;
  const label = typeConfig.label || record.typeName || event.type;
  const offence = event.offence || event.reason;
  return offence ? `${label}: ${offence}` : label;
}
